import Container from "@mui/material/Container";
import { Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";

const DemoButtons = ({ setInputValue, setIsTyping }) => {
    const { isDarkMode } = useContext(ThemeContext);
    const colors = !isDarkMode ? ["#f5f5f5", "#000000", "#dfdfdf"] : ["#6e6e6e", "#ffffff", "#aeaeae"];

    const button1 = [
        'Neukunden Bonus',
        'Hallo Liebes E.On. Team,\n ich habe online gesehen, dass es gerade 200€ Bonus für Neukunden gibt. Was muss man für den Bonus tun?\n Mit freundlichen Grüßen Hannah Morser \n Lilienweg 7, 74321 Bietigheim +4915126081245 Vertragsnummer: 023473828'
    ];
    const button2 = [
        'Vertrags Widerruf',
        'Sehr geehrte Damen und Herren,\n' +
        'hiermit wird der folgende Vertrag fristgerecht widerrufen.\n\n' +
        'Zählernummer: 754782\n Vertragsnummer: 49934853\n' +
        'MFG\n' +
        'Meryem Huhn\n \n' +
        'Baumallee 10\n' +
        '04199 Bamberg\n'];
    const button3 = [
        'Abschlagskosten Reduzierung',
        'Sehr geehrte Damen und Herren,\n' +
        'wir bitten Sie um die Reduzierung der Abschlagskosten der Eheleute Reuter, da das Objekt am Wilmsenplatz 23 in 64085 Haldensleben ab dem 15.08.2023 unbewohnt ist und verkauft wird.\n' +
        'Mit freundlichen Grüßen\n' +
        'Gülay Geißler\n' +
        'Amazon GmBH\n' +
        'Emmerich-Hartung-Ring 74\n' +
        '64085 Haldensleben\n' +
        'Tel.: 02390 324348'
    ];

    const buttons = [button1, button2, button3];

    const handleButtonClick = (text) => {
        setIsTyping(false);
        setInputValue(text);
    };

    return (
        <Container
            maxWidth={false}
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-evenly',
                alignItems: 'center',
                marginTop: 5,
                gap: { xs: 2, sm: 0 },
            }}
        >
            {buttons.map((text, index) => (
                <Paper
                    key={index}
                    elevation={3}
                    onClick={() => handleButtonClick(text[1])}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        userSelect: 'none',
                        transition: 'all 0.3s ease',
                        backgroundColor: colors[0],
                        color: colors[1],
                        width: { xs: '90%', sm: '300px' },
                        height: { xs: 'auto', sm: 'auto' },
                        minHeight: '350px',
                        '&:hover': {
                            backgroundColor: colors[2],
                        }
                    }}
                >
                    <Typography fontWeight="bold" marginBottom={1} textAlign="center">
                        {text[0]}
                    </Typography>
                    <Typography textAlign="center">
                        {text[1]}
                    </Typography>
                </Paper>
            ))}
        </Container>
    );
};

export default DemoButtons;